export var ApiServiceLevelEnum;
(function (ApiServiceLevelEnum) {
    ApiServiceLevelEnum["FREE"] = "free";
    ApiServiceLevelEnum["BUSINESS"] = "business";
    ApiServiceLevelEnum["UNLIMITED"] = "unlimited";
})(ApiServiceLevelEnum || (ApiServiceLevelEnum = {}));
